$(document).ready(function () {
  $(document).on("click", '.bf_hero_left_gallery_slides img', function(e){
        e.preventDefault();
        $(".bf_hero_left_gallery_main").attr('src', $(this).attr('data-src'));    
  });

  $(document).on("click", '.bf_hero_right_tabs_header button', function(e){
        e.preventDefault();
        let target = $(this).attr('data-target');
        $('.bf_hero_right_tabs_header button, .bf_hero_right_tabs_body_inner').removeClass('active');
        $(this).addClass('active');
        $(target).addClass('active');
    });

    $(document).on("click", '.bf_faq_item button', function(e){
        e.preventDefault();
        $('.bf_faq_item button').not($(this)).removeClass('active');
        $('.bf_faq_tab_body').not($(this).next('.bf_faq_tab_body')).slideUp();
        $(this).toggleClass('active');
        $(this).next('.bf_faq_tab_body').slideToggle();
    });
    var toggle = true;
    $(document).on("click", '.bf_reviews_item .bf_reviews_button button', function(e){
        e.preventDefault();
        if (toggle) {
            $(this).text('Read Less');
            $(this).parents('.bf_reviews_button').prev('.bf_para').addClass('bf_show_full');
        } else {
            $(this).text('Read Full Review');
            $(this).parents('.bf_reviews_button').prev('.bf_para').removeClass('bf_show_full');
        }
        toggle = !toggle;
    });
      $(document).on("click", '.bf_add_to_cart_btn', function(e){
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $('html, body').offset().top,
        });
    });
})